import { SideDrawerTriggerDirective } from './directives/side-drawer-trigger.directive';
import { SideDrawerComponent } from './side-drawer/side-drawer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { ModalComponent } from './modal/modal.component';
import { ModalTriggerDirective } from './directives/modal-trigger.directive';
import { JQ_TOKEN } from '@iq-central-front-end/shared/ui/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { UploadComponent } from './fileupload/upload/upload.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FileUploadModule } from 'ng2-file-upload';
import { BarRatingModule } from 'ngx-bar-rating';
import { YinkaModalComponent } from './yinka-modal/yinka-modal.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import { RetryComponent } from './retry/retry.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

const jQuery = window['$'];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    BarRatingModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    FileUploadModule,
    HttpClientModule,
    AngularEditorModule,
    BsDatepickerModule.forRoot(),
    NgbModule,
    NgxPaginationModule,
    CarouselModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
    }),
    NgxExtendedPdfViewerModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  exports: [
    NgxSpinnerModule,
    ToastrModule,
    HttpClientModule,
    FormsModule,
    NgSelectModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    CarouselModule,
    FileUploadModule,
    BarRatingModule,
    ModalComponent,
    FontAwesomeModule,
    ModalTriggerDirective,
    SideDrawerTriggerDirective,
    BsDatepickerModule,
    SideDrawerComponent,
    AngularEditorModule,
    NgbModule,
    UploadComponent,
    RetryComponent,
    NgxExtendedPdfViewerModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  providers: [{ provide: JQ_TOKEN, useValue: jQuery }],
  declarations: [
    ModalComponent,
    ModalTriggerDirective,
    UploadComponent,
    YinkaModalComponent,
    SideDrawerTriggerDirective,
    SideDrawerComponent,
    RetryComponent,
  ],
})
export class ShareModule {}
